// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__VtalH","label":"styles_label__4tNeH","icon":"styles_icon__0EVJ8"};